import React, { useContext } from 'react';
import GlyphEditor from './GlyphEditor';
import { Glyph } from 'konect-model';
import { AppContext } from '../App';

interface PresentationProps {}

const Presentation = (props: PresentationProps) => {
    const { project } = useContext(AppContext);

    // Use the first glyph as the parent container, or create a temporary one
    // The actual content comes from the loaded graph XML which contains all glyphs
    const presentationGlyph = project.glyphs.length > 0 ? project.glyphs[0] : new Glyph("presentation-glyph");

    return <GlyphEditor
        initialGlyph={presentationGlyph}
        presentationMode={true}
    />;
}

export default Presentation;
